import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion, AnimatePresence } from "framer-motion";

export const BetaBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    // Check if banner was dismissed in the last 24 hours
    const dismissedAt = localStorage.getItem("betaBannerDismissed");
    if (dismissedAt) {
      const dismissedTime = new Date(dismissedAt).getTime();
      const now = new Date().getTime();
      const hoursPassed = (now - dismissedTime) / (1000 * 60 * 60);
      
      if (hoursPassed < 24) {
        setShouldShow(false);
        return;
      }
    }
    
    setShouldShow(true);
    // Show banner after 1 second delay
    setTimeout(() => setIsVisible(true), 1000);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem("betaBannerDismissed", new Date().toISOString());
  };

  if (!shouldShow) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ duration: 0.3 }}
          className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-primary/90 to-accent/90 backdrop-blur-sm border-b border-primary/20"
        >
          <div className="container mx-auto px-4 py-3">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-3 flex-1">
                <div className="hidden sm:flex items-center justify-center w-8 h-8 rounded-full bg-background/20 backdrop-blur-sm">
                  <span className="text-lg">🚧</span>
                </div>
                <p className="text-sm md:text-base text-primary-foreground font-medium">
                  <span className="font-bold">We're in Beta!</span> Help shape BitcoinMind by sharing your feedback using the feedback button.
                </p>
              </div>
              
              <div className="flex items-center gap-2">
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={handleDismiss}
                  className="text-primary-foreground hover:bg-background/20"
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
